
import React from 'react';
import { Container } from './styles';
import modal from './Modal';
import { IModalMessage } from '../..';


interface IModalContainerProps {
  messages: IModalMessage[];
  className: string;
  closeButton: boolean;
}

const ModalContainer: React.FC<IModalContainerProps> = ({ messages, className, closeButton = true }) => {
  return (
    <Container>
      {messages.map(item =>
        modal({ key: item.id, title: item.title, content: item.content, className: item?.theme || 'whiteModal', closeButton, theme: item?.theme || '', background: item?.background }),
      )}
    </Container>
  );
};

export default ModalContainer;
